import React, { useEffect, useState } from "react";
import "./Dropdown.scss";

// Icons used
import { ArrowDown, ArrowUp, CalenderIcon } from "../../icons";

const DropdownWithIcon = ({
  name, // Name for hidden input (used for form submission)
  options = [], // Array of selectable options: { label: string, value: any, selected?: boolean }
  size = "md", // Size variant for styling: 'sm', 'md', 'lg'
  placeholder = "Select Item", // Placeholder text when nothing selected
  className = "", // Additional class names for customization
  icon: Icon = CalenderIcon, // Icon to render next to each option (default: CalenderIcon)
  disabled = false, // If true, disables the dropdown
  onChange, // Callback function triggered on selection
}) => {
  /* === useState === */
  const [open, setOpen] = useState(false); // Whether the dropdown is open
  const [selected, setSelected] = useState(null); // Currently selected option
  /* === End useState === */

  /* === useEffect: Preselect default === */
  useEffect(() => {
    const preselected = options.find((opt) => opt.selected);
    if (preselected) {
      setSelected(preselected); // Set default selected option
      if (onChange) onChange(preselected.value); // Notify parent if needed
    }
  }, [options]);
  /* === End useEffect === */

  /* === Event Handler === */
  const handleSelect = (option) => {
    if (disabled) return; // Don't allow selection if disabled
    setSelected(option); // Update selected state
    setOpen(false); // Close dropdown
    if (onChange) onChange(option.value); // Notify parent
  };
  /* === End Event Handler === */

  return (
    <div
      className={`dropdownWrapper ${size} ${className} ${
        disabled ? "disabled" : ""
      }`}
    >
      <input
        type="hidden"
        name={name}
        value={selected?.value || ""}
        disabled={disabled}
      />

      <div className="borderWrapper">
        <div
          className="dropdownSelect borderInner"
          onClick={() => !disabled && setOpen((prev) => !prev)}
          tabIndex={disabled ? -1 : 0} // Make focusable unless disabled
          onBlur={() => setTimeout(() => setOpen(false), 150)} // Close after losing focus
        >
          <span
            className={selected?.label ? "textLabel selected" : "textLabel"}
          >
            {selected?.label || placeholder}
          </span>
          <span className={selected?.label ? "arrow selected" : "arrow"}>
            {open ? <ArrowUp size={size} /> : <ArrowDown size={size} />}
          </span>
        </div>
      </div>

      {/* Options Dropdown List */}
      {open && (
        <div className="dropdownOptionBox">
          <div className="borderWrapper">
            <div className="dropdownOptionInner borderInner">
              {options.map((opt) => (
                <div
                  key={opt.value}
                  className={
                    selected?.value === opt.value
                      ? "selected dropdownOption borderWrapperJustOneCorner"
                      : "dropdownOption borderWrapperJustOneCorner"
                  }
                  onClick={() => handleSelect(opt)}
                >
                  <Icon className="" /> {/* Icon next to each label */}
                  {opt.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownWithIcon;
